"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _deepEqual = _interopRequireDefault(require("deep-equal"));

var _connectToMedia = _interopRequireDefault(require("../../../Media/connectToMedia"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var AnimatorView = /*#__PURE__*/function (_Component) {
  _inheritsLoose(AnimatorView, _Component);

  function AnimatorView(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = AnimatorView.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return !(0, _deepEqual["default"])(nextProps, this.props);
  };

  _proto.innerStyleChanges = function innerStyleChanges() {
    var frame = this.props.frame >= 0 ? [this.props.frame] : [-100];

    if (this.props.queries) {
      var searchedQuery = this.props.queries.find(function (val) {
        return val.hits.map(function (item) {
          return item.p;
        }).includes(frame[0]);
      });

      if (searchedQuery) {
        var queryLength = searchedQuery.label.trim().split(" ").length;

        for (var i = 1; i < queryLength; i++) {
          frame.push(frame[0] + i);
        }
      }
    }

    return "\n      " + frame.map(function (val) {
      return ".word-index-" + val;
    }).join(", ") + " {\n        background-color: rgba(170, 217, 187, 01);\n        font-weight: bold;\n        color: rgba(93,44,143,1);\n      }\n\n      .word-index-" + (frame[0] - 1) + ",\n      .word-index-" + (frame[frame.length - 1] + 1) + " {\n        background-color: rgba(170, 217, 187, 0.666);\n      }\n\n      .word-index-" + (frame[0] - 2) + ",\n      .word-index-" + (frame[frame.length - 1] + 2) + " {\n        background-color: rgba(170, 217, 187, 0.33);\n      }\n\n      .word-range-search {\n        color: red;\n        border-bottom: 1px solid black;\n      }\n\n      .word-range-true {\n        font-weight: bold;\n        color: rgba(93,44,143,1);\n      }\n\n      .chat-turn-highlighted {\n        font-weight: bold;\n        color: rgba(93,44,143,1);\n      }\n\n    ";
  };

  _proto.render = function render() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("input", {
      value: this.props.frame,
      id: "chat-frame-value",
      type: "hidden"
    }), /*#__PURE__*/_react["default"].createElement("style", {
      dangerouslySetInnerHTML: {
        __html: this.innerStyleChanges()
      }
    }));
  };

  return AnimatorView;
}(_react.Component);

var _default = (0, _connectToMedia["default"])(function (state) {
  return {
    queries: state.query
  };
})(AnimatorView);

exports["default"] = _default;